import { api } from "../axios";
import type { NoteDetail, NoteListItem, PaginatedResponse } from "../../types";

type NotesAnalysisResult = {
  client_suggestions: Array<{
    id: number;
    name: string;
    status: string;
    similarity: number;
  }>;
  task_suggestions: Array<{ title: string; due_hint: string }>;
};

export function analyseNote(text: string): Promise<NotesAnalysisResult> {
  return api.post("notes/analyze/", {
    raw_text: text,
  });
}

export function getScribeToken(): Promise<{ token: string }> {
  return api.get("notes/scribe-token/");
}

type SaveNotePayload = {
  clientId?: number;
  text: string;
};

type UpdateNotePayload = {
  summary?: string;
  clientId?: number | null;
  id: number;
};

type SaveNoteResponse = {
  note: NoteListItem;
};

export function saveNote(payload: SaveNotePayload): Promise<SaveNoteResponse> {
  return api.post("notes/", {
    client_id: payload.clientId,
    raw_text: payload.text,
  });
}

export function updateNote(payload: UpdateNotePayload): Promise<NoteDetail> {
  return api.patch(`notes/${payload.id}/`, {
    client_id: payload.clientId,
    summary: payload.summary,
  });
}

export function deleteNote(id: number) {
  return api.delete(`notes/${id}/`);
}

export function getNotes(params?: {
  clientId?: number;
  page?: number;
}): Promise<PaginatedResponse<NoteListItem>> {
  return api.get("notes/", {
    params: { client_id: params?.clientId, page: params?.page },
  });
}

export function getNote(id: number): Promise<NoteDetail> {
  return api.get(`notes/${id}/`);
}
